import { List, Skeleton } from 'antd'
import React, { useEffect, useState } from 'react'
import { BASE_URL } from '../constants/Url';
import { useNavigate } from 'react-router';
import { showFormatDate } from '../utils/Utils';
import { useTranslation } from 'react-i18next';
import { newsData } from '../constants/TempData';
import { Link } from 'react-router-dom';
import BackHome from '../components/BackHome';

export default function BlogPage() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [blogs, setBlogs] = useState([
        {
            cover: "",
            video: "",
            title: "",
            description: "",
            company: "",
            publishedDate: "",
        }
    ]);

    useEffect(() => {
        fetchBlog();
    }, [])

    const fetchBlog = async () => {
        const res = newsData;
        setBlogs([...res])
    }

    const handleViewDetail = (item) => {
        navigate(`/blog/${item.code}`, { state: { news: item } });
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    const isVideoFile = (url) => {
        return /\.(mp4|webm|ogg)$/i.test(url);
    }

    return (
        <>
            <BackHome title={t("Blog")} t={t}/>
            <div style={{ padding: "40px 0px" }}>
                <div className='esi-std-container'>
                    <div className='esi-content-title'>
                        {t("Blog")}
                        <div className='esi-secondary-line'></div>
                    </div>
                    <div className='esi-std-white-space'>
                        <List
                            className="mt-4"
                            grid={{
                                gutter: { xs: 10, md: 20, lg: 30 },
                                xs: 1,
                                sm: 1,
                                md: 1,
                                lg: 2,
                                xl: 2,
                                xxl: 2,
                            }}
                            pagination={false}
                            dataSource={blogs}
                            renderItem={(item) => (
                                loading ? (
                                    <List.Item>
                                        <div className="grid grid-cols-7 cursor-pointer select-none">
                                            <div className="col-span-3 overflow-hidden rounded-[0.5rem]">
                                                <Skeleton.Image rootClassName='esi-sub-news-card-image' style={{ cursor: "pointer" }} className='esi-sub-news-card-image' active={true} />
                                            </div>
                                            <div className='col-span-4 px-3 flex flex-col justify-between'>
                                                <div className='flex flex-col gap-1'>
                                                    <Skeleton.Input className="esi-news-card-title max-w-[50%] line-clamp-2" active block />
                                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                                    <Skeleton.Input
                                                        rootClassName='max-sm:!hidden md:!block'
                                                        className="esi-news-card-description max-w-[100%] line-clamp-2 sm:line-clamp-3" active block />
                                                </div>
                                            </div>
                                        </div>
                                    </List.Item>
                                ) : (
                                    <List.Item>
                                        <div className="grid grid-cols-7" onClick={() => handleViewDetail(item)}>
                                            <div className="col-span-3 overflow-hidden rounded-[0.5rem]">
                                                {isVideoFile(item.video) ? (
                                                    <video
                                                        className="esi-sub-news-card-image"
                                                        style={{
                                                            width: '100%',
                                                            height: 'auto',
                                                            maxHeight: '250px',
                                                            objectFit: 'cover',
                                                            borderRadius: '0.5rem',
                                                            cursor: 'pointer'
                                                        }}
                                                        controls
                                                        muted
                                                        preload="metadata"
                                                    >
                                                        <source src={`${BASE_URL}${item.video}`} type="video/mp4" />
                                                    </video>
                                                ) : (
                                                    <img
                                                        className="esi-sub-news-card-image"
                                                        style={{ cursor: "pointer" }}
                                                        src={`${BASE_URL}${item.cover}`}
                                                        alt={item.fileName}
                                                    />
                                                )}
                                            </div>
                                            <div className='col-span-4 px-3 flex flex-col justify-between'>
                                                <div className='flex flex-col gap-1'>
                                                    <div className="esi-news-card-title max-w-[100%] line-clamp-2">{item.title}</div>
                                                    <div className='esi-news-card-dob'>{showFormatDate(item.publishedDate)}</div>
                                                    <div className="esi-news-card-description max-w-[100%] line-clamp-2 sm:line-clamp-3">{item.description}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </List.Item>
                                )
                            )}
                        />
                    </div>

                    {loading ? (
                        <div className='text-start w-25 text-white md:text-black absolute left-[24px] bottom-[6px] md:relative md:left-0 md:bottom-0 esi-news-card-title max-w-[calc(100%-24px*2)] md:max-w-[25%] mt-3 line-clamp-2 d-flex m-auto'>
                            <Skeleton.Input active block style={{ height: "50px", backgroundColor: "rgba(17, 152, 17, 0.2)", width: "25%", margin: "auto", display: "flex" }} />
                        </div>
                    ) : (
                        <div className="text-center mt-10">
                            <Link
                                to="#!"
                                className="px-6 py-3 text-white text-lg font-semibold rounded-lg shadow transition duration-300"
                                style={{ backgroundColor: '#119811' }}
                            >
                                {t("See More")}
                            </Link>
                        </div>
                    )}

                    <div className='h-[40px]'></div>
                </div>
            </div>
        </>
    )
}
